import {Pipe, PipeTransform} from '@angular/core';

import {Stockroom} from '../../models/stockroom/stockroom';

@Pipe({
  name: "filterByCompanyId"
})
export class StockroomFilterByCompany implements PipeTransform {

  transform(stockrooms: Stockroom[], companyId: string): Stockroom[] {
    if (stockrooms != null && companyId != null) {
      return stockrooms.filter(str => str.companyId == companyId);
    }
    return [];
  }
}
